var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntakeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.92 9.19L17.09 8.36C16.35 7.62 15.05 7.61 14.3 8.36L13.21 9.45L8.65 14.01C8.55 14.11 8.48 14.25 8.44 14.39L7.79 17.6C7.74 17.85 7.82 18.1 8 18.28C8.14 18.42 8.33 18.5 8.53 18.5C8.58 18.5 8.63 18.5 8.68 18.48L11.89 17.83C12.03 17.8 12.17 17.73 12.27 17.63L16.83 13.07L17.92 11.98C18.69 11.21 18.69 9.96 17.92 9.19ZM15.37 9.43C15.55 9.25 15.86 9.25 16.04 9.43L16.87 10.26C17.05 10.44 17.05 10.74 16.87 10.93L16.31 11.49L14.82 10L15.38 9.44L15.37 9.43ZM11.37 16.41L9.5 16.79L9.88 14.92L13.75 11.05L15.24 12.54L11.37 16.41ZM18.5 4.04V6.15C18.5 6.56 18.16 6.9 17.75 6.9C17.34 6.9 17 6.56 17 6.15V4.04C17 3.19 16.31 2.5 15.46 2.5H4.04C3.19 2.5 2.5 3.19 2.5 4.04V15.45C2.5 16.3 3.19 16.99 4.04 16.99H5.65C6.06 16.99 6.4 17.33 6.4 17.74C6.4 18.15 6.06 18.49 5.65 18.49H4.04C2.36 18.49 1 17.12 1 15.45V4.04C1 2.37 2.37 1 4.04 1H15.45C17.13 1 18.49 2.37 18.49 4.04H18.5ZM4.52 5.6C4.52 5.19 4.86 4.85 5.27 4.85H11.47C11.88 4.85 12.22 5.19 12.22 5.6C12.22 6.01 11.88 6.35 11.47 6.35H5.27C4.86 6.35 4.52 6.01 4.52 5.6ZM4.52 8.78C4.52 8.37 4.86 8.03 5.27 8.03H9.96C10.37 8.03 10.71 8.37 10.71 8.78C10.71 9.19 10.37 9.53 9.96 9.53H5.27C4.86 9.53 4.52 9.19 4.52 8.78Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeOff);
export default __webpack_public_path__ + "static/media/intakeOff.fdf07a9775243944e8964eab931e45f4.svg";
export { ForwardRef as ReactComponent };